import type { IMasterDataDistributionCenterRepository } from "@src/domain/repositories/masterData";
import type { CreateMasterDataDistributionCenterDTO } from "@src/domain/dto/masterData";

export class CreateMasterDataDistributionCenterUseCase {
  private readonly repository: IMasterDataDistributionCenterRepository;

  constructor(repository: IMasterDataDistributionCenterRepository) {
    this.repository = repository;
  }

  execute(params: CreateMasterDataDistributionCenterDTO) {
    return this.repository.createDistributionCenter(params);
  }
}
